import { readerNavigationContext } from "../../../../hookstate/readerNavigationContextStore";
import { ReaderNavigationContext, NavigationTrigger } from "../../../reader/types";

export function buildSearchNavigationContext(
  query: string,
  cardPosition: number,
): ReaderNavigationContext {
  return {
    area: "search",
    trigger: NavigationTrigger.searchResultCard,
    cardPosition,
    q: query,
  };
}

/**
 * Compute the visual card position based on the actual display order.
 * Each section's items are counted in order; the position is the
 * cumulative offset of earlier sections plus the index within the section.
 */
export function getTypedSearchResultPosition({
  section,
  index,
  sectionOrder,
  sectionCounts,
}: {
  section: string;
  index: number;
  sectionOrder: string[];
  sectionCounts: Record<string, number>;
}): number {
  let offset = 0;
  for (const key of sectionOrder) {
    if (key === section) break;
    offset += sectionCounts[key] ?? 0;
  }
  return offset + index;
}

export function storeSearchNavigationContext(
  query: string,
  cardPosition: number,
): ReaderNavigationContext {
  const context = buildSearchNavigationContext(query, cardPosition);
  readerNavigationContext.set(context);
  return context;
}
